import { render, staticRenderFns } from "./RotationShapeControls.vue?vue&type=template&id=3fa0f9ca&scoped=true"
import script from "./RotationShapeControls.vue?vue&type=script&lang=ts"
export * from "./RotationShapeControls.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./RotationShapeControls.vue?vue&type=style&index=0&id=3fa0f9ca&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./RotationShapeControls.vue?vue&type=style&index=1&id=3fa0f9ca&prod&lang=scss&scoped=true")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3fa0f9ca",
  null
  ,true
)

export default component.exports